import { ComponentType } from 'react'

import LegacyTextAreaField from '@/components/FormLegacy/FormFieldsV2/TextAreaField'
import LegacyTextField from '@/components/FormLegacy/FormFieldsV2/TextField'
import LegacyToggleField from '@/components/FormLegacy/FormFieldsV2/ToggleField'

// Note: these are untyped .jsx components (no props type export) whose optional props are
// destructured without defaults, so TS's allowJs inference treats them as required when
// consumed from a .tsx file — even though the legacy code itself never passed them. Cast to
// a loosely-typed ComponentType once here rather than repeating this per call site/per file.
export const TextField = LegacyTextField as unknown as ComponentType<Record<string, unknown>>
export const TextAreaField = LegacyTextAreaField as unknown as ComponentType<
  Record<string, unknown>
>
export const ToggleField = LegacyToggleField as unknown as ComponentType<Record<string, unknown>>
